import { createSlice } from '@reduxjs/toolkit';
var initialState = {
  statusPayment: 'Initial',
  cardNumberCode: null,
  loading: false
};
export var savedCardsSlice = createSlice({
  name: 'features/savedCards',
  initialState: initialState,
  reducers: {
    setLinkedCardNumber: function setLinkedCardNumber(state, action) {
      state.cardNumberCode = action.payload;
    },
    setStatusPayment: function setStatusPayment(state, action) {
      state.statusPayment = action.payload;
    },
    setLoading: function setLoading(state, action) {
      state.loading = action.payload;
    }
  },
  extraReducers: {}
});